<template>
<div class="chapter">
<div class="inner_page">
<div id="CreatingMissionalCulture.html" xml:lang="en-US" xmlns:xml="http://www.w3.org/XML/1998/namespace">
<div class="image">
<p class="para-style-override-7"><img alt="Praxis" src="Images/Praxis_Quarter.jpg"/></p>
</div>
<div class="Basic-Text-Frame">
<p class="Normal para-style-override-3"><span class="char-style-override-5">“…to equip his people for works of service,<br/>
      so that the body of Christ may be built up.”</span></p>
<p class="Normal para-style-override-4"><span class="char-style-override-5">ephesians 4:12</span></p>
<p class="Normal para-style-override-5"></p>
<p class="Normal para-style-override-6"><span class="char-style-override-6">God has called us to ministry. But it’s not enough to have a vision for ministry if you don’t have the practical skills for it. Nor is it enough to do the work of ministry if what you do is headed in the wrong direction. We need both vision</span> <span class="char-style-override-7">and</span> <span class="char-style-override-6">expertise for effective ministry. We need</span> <span class="char-style-override-8">praxis.</span></p>
<p class="Normal para-style-override-6"><span class="char-style-override-6">Praxis puts theory into practice. It brings cutting-edge ministry expertise from visionary practitioners. You’ll find sound biblical and theological foundations for ministry in the real world, with concrete examples for effective action and pastoral ministry. Praxis books are more than the “how to” – they’re also the “why to.” And because</span> <span class="char-style-override-7">being</span> <span class="char-style-override-6">is every bit as important as</span> <span class="char-style-override-7">doing</span><span class="char-style-override-6">, Praxis attends to the inner life of the leader as well as the outer work of ministry. Feed your soul, and feed your ministry.</span></p>
<p class="Normal para-style-override-6"><span class="char-style-override-6">If you are called to ministry, you know you can’t do it on your own. Let Praxis provide the companions you need to equip God’s people for life in the kingdom.</span></p>
<p class="Normal para-style-override-5"></p>
<p class="Normal para-style-override-3"><span class="char-style-override-9"> <br/>
<a href="http://www.ivpress.com/praxis" target="_blank">www.ivpress.com/praxis</a></span></p>
</div>
<div class="story">
<p class="Body"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"></p>
<p class="copyright"><br/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Praxis.vue?466de30a